import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=ff4cad40&scoped=true&"
import script from "./materials.vue?vue&type=script&lang=ts&"
export * from "./materials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4cad40",
  null
  
)

export default component.exports